import type { HTMLAttributes, ReactNode, Ref } from "react";
import { forwardRef } from "react";

import { ColorInput } from "metabase/common/components/ColorInput";
import { ColorPill } from "metabase/common/components/ColorPill";
import { Group, Popover } from "metabase/ui";

export interface ColorPickerTriggerProps extends Omit<
  HTMLAttributes<HTMLDivElement>,
  "onChange" | "onClick"
> {
  value: string;
  label?: ReactNode;
  placeholder?: string;
  isAuto?: boolean;
  onClick?: () => void;
  onChange?: (value?: string) => void;
}

export const ColorPickerTrigger = forwardRef(function ColorPickerTrigger(
  {
    value,
    label,
    placeholder,
    isAuto,
    onClick,
    onChange,
    ...props
  }: ColorPickerTriggerProps,
  ref: Ref<HTMLDivElement>,
) {
  return (
    <Group {...props} ref={ref} wrap="nowrap">
      <Popover.Target>
        <ColorPill color={value} isAuto={isAuto} onClick={onClick} />
      </Popover.Target>
      <ColorInput
        value={!isAuto ? value : undefined}
        label={label}
        placeholder={placeholder}
        fullWidth
        onChange={onChange}
      />
    </Group>
  );
});
